// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar[data-v-e14b73fc]{width:32px;height:32px;border-radius:32px;-o-object-fit:cover;object-fit:cover;vertical-align:middle}", ""]);
// Exports
module.exports = exports;
